module.exports = __webpack_public_path__ + "static/img/sedan-blue.3b751f1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/sedan-blue.svg
// module id = Syxk
// module chunks = 74